import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.min.css'
import { BenQuery } from './BenQuery'
import { BenFn } from '@/common/BenFn'
const objs = {} as { [key: string]: any }
export class BenSwiper {
  static async init(selector: HTMLElement, { id = '', bind = '', initialSlide = 0, spaceBetween = 0, loop = false, autoplay = false as any, pagination, prevEl, nextEl, perView = 'auto', breakpoints, effect, control = '', allowTouchMove = true, autoHeight = false }) {
    const isMobile = BenFn.isMobileByWidth()
    let slidesPerView = null as any
    if (breakpoints) {
      breakpoints = BenQuery.paseJson(breakpoints) || {}
      slidesPerView = void 0
    } else {
      slidesPerView = isMobile ? '1' : perView
    }
    spaceBetween = isMobile ? 0 : spaceBetween
    const paginationSet = control === 'none' ? false : { el: pagination, clickable: true }
    const navigation = control === 'none' ? false : { nextEl, prevEl }
    if (autoplay === true) {
      autoplay = { delay: 6000 }
    }
    const swiper = new Swiper(selector, {
      autoHeight,
      autoplay,
      allowTouchMove,
      effect,
      spaceBetween,
      slidesPerView,
      breakpoints,
      initialSlide,
      loop,
      pagination: paginationSet,
      navigation,
      centeredSlides: bind !== '',
      centeredSlidesBounds: bind !== '',
      // slideToClickedSlide: true,
    })
    if (id !== '') objs[id] = swiper
    let bindObj = null as any
    swiper.slides[initialSlide].classList.add('active')
    swiper.on('click', function (swiper, event) {
      const clickedIndex = swiper.clickedIndex
      const target = event.target
      const openImage = target.getAttribute('open-image')
      if (openImage) {
        const src = target.getAttribute('src')
        if (src) window.open(src)
      }
      //.active要自己加的，因为一屏多个的话，activeIndex是没意义的
      if (bindObj) {
        _slideToAndUpdateActive({ swiper, activeIndex: clickedIndex })
        _slideToAndUpdateActive({ swiper: bindObj, activeIndex: clickedIndex })
      }
    })
    await BenFn.sleep(1000)
    bindObj = bind === '' ? null : objs[bind]
    if (bindObj) {
      bindObj.on('click', (bindObj, event) => {
        const clickedIndex = bindObj.clickedIndex
        _slideToAndUpdateActive({ swiper, activeIndex: clickedIndex })
      })
      //这里只能是那种一屏一个slide的，不然activeIndex会没意义
      bindObj.on('slideChangeTransitionEnd', (bindObj) => {
        const activeIndex = bindObj.activeIndex
        _slideToAndUpdateActive({ swiper, activeIndex })
      })
    }
    return swiper
  }

  static initCoverflow(selector: HTMLElement, { spaceBetween = 0, loop = true, pagination, prevEl, nextEl, perView = 'auto' }) {
    let activeIndex = 0
    const isMobile = BenFn.isMobileByWidth()
    const slidesPerView = isMobile ? '1' : perView
    spaceBetween = isMobile ? 0 : spaceBetween
    const swiper = new Swiper(selector, {
      effect: 'coverflow',
      grabCursor: false,
      centeredSlides: true,
      loop,
      spaceBetween,
      slidesPerView,
      slideToClickedSlide: true,
      coverflowEffect: { rotate: 0, stretch: 0, depth: 100, modifier: 2.5 },
      pagination: { el: pagination, clickable: true },
      navigation: { nextEl, prevEl },
    })
    swiper.on('click', function (swiper, event) {
      const target = event.target
      const openImage = target.getAttribute('open-image')
      if (!openImage) return
      const src = target.getAttribute('src')
      if (!src) return
      const $slide = event.target.closest('.swiper-slide')
      const index = Number($slide.getAttribute('data-swiper-slide-index'))
      if (index === activeIndex) window.open(src)
    })
    swiper.on('slideChange', async (swiper, event) => {
      await BenQuery.sleep(30)
      activeIndex = swiper.realIndex
    })
    return swiper
  }
}

function _slideToAndUpdateActive({ swiper, activeIndex }) {
  swiper.slideTo(activeIndex)
  const slideList = swiper.slides as HTMLElement[]
  _updateActive(slideList, activeIndex)
}

function _updateActive(slides: HTMLElement[], activeIndex) {
  slides.forEach((slideEl, index) => {
    if (activeIndex === index) {
      slideEl.classList.add('active')
    } else {
      slideEl.classList.remove('active')
    }
  })
}

function _findActiveIndex(list: HTMLElement[]) {
  let activeIndex = null as null | number
  list.forEach((item, index) => {
    if (item.classList.contains('active')) {
      activeIndex = index
    }
  })
  return activeIndex
}
